//@flow

import styled from "styled-components"
import TitleContainer from "../../Shared/TitleContainer"
import TitleContent from "../../Shared/TitleContent"
import Title from "../../Shared/Title"

export const Intro = TitleContainer.extend`
  width: 680px;
  top: 114px;
  right: 120px;
  position: absolute;
  z-index: 2;
`

export const IntroTitle = Title.extend`
  font-size: 72px;
  line-height: 0.875em;
  margin: 0.25rem 0 1.75rem 0;
`.withComponent("h1")

export const IntroDescription = TitleContent.extend`
  font-size: 30px;
  color: #132048;
  margin-top: 0;
  font-weight: 400;
`.withComponent("p")

export const ContentContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #16b4e3, #a5d9f2);
`

export const CloudOne = styled.div`
  position: absolute;
  top: 184px;
  left: -108px;
  height: 256px;
  width: 758px;
  z-index: 0;
`

export const CloudTwo = CloudOne.extend`
  top: 131px;
  left: 772px;
  height: 181px;
  width: 523px;
`

export const CloudThree = CloudOne.extend`
  top: 616px;
  left: 1584px;
  height: 171px;
  width: 436px;
`

export const Ozone = styled.div`
  position: absolute;
  z-index: 1;
  left: -800px;
  bottom: -100px;
  width: 2465px;
  height: 828px;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Intro/UI.js